<template>
  <div>
    <!-- 左侧箭头按钮 -->
    <div class="arrow-trigger" :class="{ 'active': isOpen }" @click="togglePanel">
      <i class="el-icon-arrow-right" v-if="!isOpen"></i>
      <i class="el-icon-arrow-left" v-if="isOpen"></i>
    </div>
    
    <!-- 左侧弹出面板 -->
    <transition name="slide-left">
      <div v-show="isOpen" class="config-panel">
        <div class="panel-header">
          <h3>高考专业选择：雷达图匹配系统</h3>
        </div>
        
        <div class="panel-content">
          <!-- 1. 个人画像表单组件 -->
          <div class="section">
            <PersonalProfileForm 
              v-model="formData" 
              @change="handleFormChange"
              ref="profileForm"
            />
          </div>
          
          <!-- 2. 查看匹配雷达图 -->
          <div class="section">
            <h4 class="section-title">2 查看匹配雷达图</h4>
            <div class="info-text">
              雷达图将在右侧主区域显示。调整个人画像后，雷达图会实时更新，展示你与备选专业的匹配度对比。
            </div>
          </div>
          
          <!-- 3. AI推荐专业组件 -->
          <div class="section">
            <AIRecommendationPanel 
              :form-data="formData"
              :selected-major="selectedMajor"
              @major-select="selectMajor"
              @major-detail-select="handleMajorDetailSelect"
              @ai-majors-update="handleAIMajorsUpdate"
              ref="aiPanel"
            />
          </div>
          
          <!-- 4. 专业详情显示 -->
          <div class="section">
            <MajorDetailDisplay 
              :selected-major-detail="selectedMajorDetail"
            />
          </div>
          
          <!-- 按钮组 -->
          <div class="button-group">
            <el-button type="default" size="small" @click="resetForm">重置输入</el-button>
            <el-button type="default" size="small" @click="saveProgress">保存进度</el-button>
          </div>
        </div>
      </div>
    </transition>
    
    <!-- 遮罩层 -->
    <transition name="fade">
      <div v-show="isOpen" class="panel-overlay" @click="togglePanel"></div>
    </transition>
  </div>
</template>

<script>
import PersonalProfileForm from './PersonalProfileForm.vue'
import AIRecommendationPanel from './AIRecommendationPanel.vue'
import MajorDetailDisplay from './MajorDetailDisplay.vue'

export default {
  name: 'ConfigPanel',
  components: {
    PersonalProfileForm,
    AIRecommendationPanel,
    MajorDetailDisplay
  },
  data () {
    return {
      isOpen: false,
      selectedMajor: 1,
      selectedMajorDetail: null,
      // 默认的备选专业
      defaultMajors: [
        {
          id: 1,
          name: '电子信息工程',
          sub_id: null, // 实际的 sub_id 需要从接口获取
          description: '核心课程:电路原理、人工智能基础 | 就业方向:珠三角电子企业工程师 | 平均薪资(广东):8k/月'
        },
        {
          id: 2,
          name: '汉语言文学(师范)',
          sub_id: null,
          description: '核心课程:教育学、语文教学法 | 就业方向:广东公立学校语文老师 | 稳定性:就业率95%'
        },
        {
          id: 3,
          name: '自动化',
          sub_id: null,
          description: '核心课程:自动控制原理、机器人技术 | 就业方向:新能源企业控制工程师 | 风险提示:行业需求波动中等'
        }
      ],
      // 当前显示的专业列表（默认或AI推荐）
      displayMajors: [],
      formData: {
        scoreRange: '',
        subjects: [],
        careerType: '',
        excludeFields: [],
        familyResource: '',
        economicSupport: 'medium',
        targetRegions: [],
        riskPreference: 'medium'
      }
    }
  },
  created () {
    // 初始化显示默认专业
    this.displayMajors = [...this.defaultMajors]
  },
  methods: {
    togglePanel () {
      this.isOpen = !this.isOpen
    },
    
    // 处理表单变化
    handleFormChange(formData) {
      this.formData = formData
      // 通知父组件表单数据变化
      this.$emit('config-change', formData)
    },
    
    // 重置表单
    resetForm () {
      this.formData = {
        scoreRange: '',
        subjects: [],
        careerType: '',
        excludeFields: [],
        familyResource: '',
        economicSupport: 'medium',
        targetRegions: [],
        riskPreference: 'medium'
      }
      
      // 重置子组件
      if (this.$refs.aiPanel) {
        this.$refs.aiPanel.resetRecommendations()
      }
      
      this.$emit('reset')
    },
    
    // 选择专业
    selectMajor (majorId) {
      this.selectedMajor = majorId
      this.$emit('major-change', majorId)
    },
    
    // 处理AI推荐更新
    handleAIMajorsUpdate(majors) {
      this.displayMajors = majors
      this.$emit('ai-majors-update', majors)
    },
    
    // 处理专业详情选择
    handleMajorDetailSelect(major) {
      this.selectedMajorDetail = major
    },
    
    
    // 保存进度
    saveProgress () {
      const data = {
        formData: this.formData,
        selectedMajor: this.selectedMajor,
        displayMajors: this.displayMajors
      }
      
      // 保存子组件的进度
      if (this.$refs.aiPanel) {
        const aiData = this.$refs.aiPanel.saveProgress()
        Object.assign(data, aiData)
      }
      
      localStorage.setItem('radarConfigData', JSON.stringify(data))
      this.$message.success('进度已保存！')
    },
    
    // 加载进度
    loadProgress () {
      const savedData = localStorage.getItem('radarConfigData')
      if (savedData) {
        const data = JSON.parse(savedData)
        this.formData = data.formData || this.formData
        this.selectedMajor = data.selectedMajor || this.selectedMajor
        this.displayMajors = data.displayMajors || this.displayMajors
        
        // 恢复子组件的进度
        if (this.$refs.aiPanel) {
          this.$refs.aiPanel.loadProgress(data)
        }
        
        // 通知父组件更新专业列表
        this.$emit('ai-majors-update', this.displayMajors)
      }
    },
  },
  mounted () {
    this.loadProgress()
    
    // 初始化时通知父组件当前的表单数据
    this.$emit('config-change', this.formData)
    
    // 确保初始化时有专业列表数据
    this.$nextTick(() => {
      if (this.$refs.aiPanel && this.$refs.aiPanel.getDisplayMajors) {
        const majors = this.$refs.aiPanel.getDisplayMajors()
        if (majors && majors.length > 0) {
          this.displayMajors = majors
          this.$emit('ai-majors-update', majors)
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.arrow-trigger {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 80px;
  background: #3b82f6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0 8px 8px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s;
  z-index: 1001;
  
  &:hover {
    background: #2563eb;
    width: 45px;
  }
  
  &.active {
    left: 400px;
  }
  
  i {
    font-size: 20px;
    font-weight: bold;
  }
}

.config-panel {
  position: fixed;
  left: 0;
  top: 0;
  width: 400px;
  height: 100vh;
  background: white;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow-y: auto;
}

.panel-header {
  padding: 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  
  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
  }
}

.panel-content {
  padding: 20px;
}

.section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 15px;
  font-weight: 700;
  color: #000;
  margin-bottom: 20px;
  padding-left: 0;
}

.info-text {
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
  padding: 12px;
  background: #f1f5f9;
  border-radius: 6px;
  border-left: 3px solid #3b82f6;
}

.button-group {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  margin-top: 20px;
}

.panel-overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
}

// 动画
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.3s ease;
}

.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 滚动条样式
.config-panel::-webkit-scrollbar {
  width: 6px;
}

.config-panel::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.config-panel::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>

